import type { AuthSessionManager } from '@app/services/AuthSessionManager'

import type { AuthSessionManagerInterface } from '@app/packages/api/AuthSessionManager'

import { createThunk } from '@app/store/thunk'

export const getAuthSession = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().lookupEnsure<AuthSessionManagerInterface>(AuthSessionSymbol)
  })

export const setAuthSession = (authSession: AuthSessionManagerInterface) =>
  createThunk((_dispatch, _getState, context) => {
    context.getRootContext().set(AuthSessionSymbol, authSession)
  })

/**
 * The concrete manager beneath any supervision wrapper, for flows that need more
 * than token supply (e.g. the server magic-link handler calling `login`). Only
 * bound on the server — client login goes through the api actions instead.
 */
export const getAuthSessionManager = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext().lookupEnsure<AuthSessionManager>(AuthSessionManagerSymbol)
  })

export const setAuthSessionManager = (manager: AuthSessionManager) =>
  createThunk((_dispatch, _getState, context) => {
    context.getRootContext().set(AuthSessionManagerSymbol, manager)
  })

const AuthSessionSymbol = Symbol('authSession')
const AuthSessionManagerSymbol = Symbol('authSessionManager')
